import { useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../hooks/useLanguage';
import ModuleLayout from '../components/ModuleLayout';
import AIAdvisor from '../components/accounting/AIAdvisor';
import ExportToolbar from '../components/accounting/ExportToolbar';

export default function AIAdvisorPage() {
  const { token, activeBranch } = useAuth();
  const { t } = useTranslation();
  const { lang } = useLanguage();
  const branchId = activeBranch?.id;
  const [advisorData, setAdvisorData] = useState(null);
  const fmt = (v) => Number(v || 0).toLocaleString(lang === 'ar' ? 'ar-SA' : 'en-SA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const buildReport = useCallback(() => {
    if (!advisorData?.analysis) return null;
    const s = advisorData.financial_summary;
    const sar = t('common.sar');
    return {
      kpis: s ? [
        { label: t('accounting.totalRevenue'), value: fmt(s.revenue), unit: sar, highlight: 'positive' },
        { label: t('accounting.totalExpenses'), value: fmt(s.expenses), unit: sar },
        { label: t('accounting.netProfit'), value: fmt(s.profit), unit: sar, highlight: s.profit >= 0 ? 'positive' : 'negative' },
        { label: t('accounting.profitMargin'), value: `${s.margin}%`, highlight: s.margin >= 0 ? 'positive' : 'negative' },
      ] : [],
      sections: [
        { type: 'text', title: t('advisor.title'), text: advisorData.analysis }
      ]
    };
  }, [advisorData, t, lang, fmt]);

  return (
    <ModuleLayout moduleKey="finance">
      <div className="space-y-5" data-testid="ai-advisor-page">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-foreground">{t('advisor.title')}</h1>
            <p className="text-sm text-muted-foreground mt-1">{activeBranch?.name || ''}</p>
          </div>
          <ExportToolbar title={t('advisor.title')} subtitle={activeBranch?.name} buildReport={buildReport} t={t} lang={lang} />
        </div>
        <AIAdvisor branchId={branchId} token={token} t={t} lang={lang} onDataReady={setAdvisorData} />
      </div>
    </ModuleLayout>
  );
}
